import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import parse from 'html-react-parser';
import { fetchNewsDetails, resetNewsDetails } from './newsAndUpdates/store/actions';
import FontResizeWidget from '../components/FontResizeWidget';
import { Loader } from '../components';
import { ACCESSIBILITY_FEATURE_ENABLED } from '../config';
import { Helmet } from 'react-helmet';
import moment from 'moment';

const NewsArticleDetail = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const newsResult = useSelector((state) => state.newsList);
  
  const [article, setArticle] = useState(null);
  const [articles, setArticles] = useState([]);

  const getRemainingContent = (content) => {
    const firstPara = content.includes('</p>') ? content.split('</p>')[0] + '</p>' : content;
    return content.replace(firstPara, '').split('<img')[0];
  };

  const getRelativeDate = (dateString) => {
    if (!dateString) return '';
    
    const articleDate = moment(dateString).startOf('day');
    const today = moment().startOf('day');
    const diffDays = today.diff(articleDate, 'days');

    if (diffDays === 0) {
      return 'today';
    } else if (diffDays === 1) {
      return 'yesterday';
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    } else if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return months === 1 ? '1 month ago' : `${months} months ago`;
    } else {
      const years = Math.floor(diffDays / 365);
      return years === 1 ? '1 year ago' : `${years} years ago`;
    }
  };


  useEffect(() => {
   
      dispatch(fetchNewsDetails(slug));
    
  }, []);

  useEffect(() => {
    if (newsResult.isSuccess && newsResult.data) {
      const articleData = newsResult.data.success?.data?.article || newsResult.data.success?.data || newsResult.data.article || newsResult.data;
      setArticle(articleData);
      dispatch(resetNewsDetails());
    } else if (newsResult.isError) {
      dispatch(resetNewsDetails());
    }
  }, [newsResult]);

  return (
    <div className="news-article-detail__page-container">
      <Helmet>
        {article?.seoMetaTags ? parse(article.seoMetaTags) : null}
      </Helmet>
      {ACCESSIBILITY_FEATURE_ENABLED && (
        <div className="news-article-detail__font-widget">
          <FontResizeWidget minSize={14} maxSize={32} step={2} defaultSize={16} />
        </div>
      )}
      
      {newsResult.isFetching ? (
        <Loader message={"Loading Article..."} />
      ) : (
        <Container className="news-article-detail__container">
          <div className="news-article-detail__main-content">
            {article ? (
              <article className='new-article'>
                {article.content && (() => {
                  const content = article.content;
                  const derivedImage = content.includes('src="') ? content.split('src="')[1]?.split('"')[0] : null;
                  const imageUrl = article?.image || derivedImage;
                  
                  return imageUrl ? (
                    <div className="news-article-detail__image-container">
                      <Link to="/news" aria-label="Back to news" className="news-article-detail__back-button news-article-detail__back-button--on-image">
                        <span className="news-article-detail__back-icon" />
                        <span className="news-article-detail__back-text">Back to news</span>
                      </Link>
                      <img
                        src={imageUrl}
                        alt={article.title}
                        title={article.title}
                        className="news-article-detail__article-image"
                      />
                    </div>
                  ) : null;
                })()}
              <div className='discription-container'>
                <div className="news-article-detail__article-header">
                  <h1 className="news-article-detail__title">{article.title}</h1>
                  {article.date && (
                    <div className="news-article-detail__meta">Posted {getRelativeDate(article.date)}</div>
                  )}
                </div>

                {article.content && (
                  <div className="news-article-detail__content-section">
                    <div className="news-article-detail__content">
                      {parse(article.content)}
                    </div>
                  </div>
                )}
              </div>
              </article>
            )  : null}
          </div>
        </Container>
      )}
    </div>
  );
};

export default NewsArticleDetail;